import {
    animate,
    AUTO_STYLE,
    state,
    style,
    transition,
    trigger
} from '@angular/animations';

const TRANSITION_DURATION = 250;

export const openCloseAnimation = trigger('openClose', [
    state(
        'true',
        style({
            height: AUTO_STYLE,
            opacity: 1,
            overflow: 'visible'
        })
    ),
    state(
        'false',
        style({
            height: 0,
            opacity: 0,
            overflow: 'hidden'
        })
    ),
    transition(
        'false <=> true',
        animate(`${TRANSITION_DURATION}ms ease-in-out`)
    )
]);

export const rotateAnimation = trigger('rotate', [
    state('true', style({transform: 'rotate(90deg)'})),
    transition('false <=> true', animate(`${TRANSITION_DURATION}ms ease-out`))
]);
